import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { DataValidator } from 'app/tools/custom-formgroup-validator';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-data-nascimento',
  templateUrl: './text-data-nascimento.component.html',
  styleUrls: ['./text-data-nascimento.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextDataNascimentoComponent implements OnInit {

  private formGroup: FormGroup;
  minDate : string;

  constructor(
    private _controlContainer: ControlContainer
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this._validator();
  }

  private _validator(){
    const minDate = new Date();
    minDate.setHours(23, 59, 59, 59);
    minDate.setFullYear(minDate.getFullYear() - 18);
    this.minDate = minDate.toISOString().split('T')[0]; 
    this.formGroup.get('dtNascimento').setValidators([DataValidator.max(minDate)]);
    this.formGroup.get('dtNascimento').updateValueAndValidity();
  }
}

